<template>
  <div class="page_ middle_" @click="hidePanel()">
    <navbar @search="fetchData" />
    <div style="" class="hline_"></div>
    <!-- <div class="tabs_wrap_ w1000_ bold_">
            <div class="item_" v-for="(item,index) in classList" :class="{active_:index==activeIndex}" @click.stop="changeIndex(index)">{{item.productClassName}}
                <div class="overlay_" v-if="item.tagList&&item.tagList.length>0" @click.stop id="overlay">
                    <div class="select_item_" v-for="item1 in item.tagList">
                        <div class="title_ bold_">{{item1.productTagName}}</div>
                        <div class="content_">
                            <span v-for='item2 in item1.productList' @click="fetchJumpLink(item2.productCode)">{{item2.productName}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    <div class="banner_wrap_">
      <a-carousel arrows autoplay>
        <div
          slot="prevArrow"
          slot-scope="props"
          class="custom-slick-arrow"
          style="zIndex: 1"
        >
          <a-icon type="left-circle" />
        </div>
        <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow">
          <a-icon type="right-circle" />
        </div>
        <div class="item_" v-for="(itemImg, indexImg) in bannerList">
          <a :href="itemImg.url">
            <img :src="itemImg.imageUrl" alt="" />
          </a>
        </div>
      </a-carousel>
    </div>
    <div class="hots_ w1000_">
      <ul>
        <li v-for="(itemp, indexp) in hotProducts" class="hotitem_">
          <img :src="itemp.productImgUrl" alt="" />
          <div @click="fetchJumpLink(itemp.coreProductId)">
            <div class="labels_wrap_ c11_">
              <label>{{ itemp.productLeftTag }}</label>
            </div>
            <div class="title_ bold_">{{ itemp.productName }}</div>
            <div class="sub_title_">{{ itemp.productDesc }}</div>
            <div class="num_ c11_">¥{{ itemp.price }}元起</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="w1000_ product_section_">
      <div class="title_">产品列表</div>
      <div class="product_list_">
        <a-list
          v-if="productList && productList.length > 0"
          :pagination="pagination"
          :data-source="productList"
          :split="false"
        >
          <a-list-item
            :key="item.code"
            slot="renderItem"
            slot-scope="item, index"
          >
            <div class="left_">
              <img :src="item.detailImgUrl" />
            </div>
            <div class="right_wrap_">
              <div class="company_">{{ item.underCompany }}</div>
              <div class="title_">{{ item.name }}</div>
              <div class="desc_">{{ item.sellingPoint || "" }}</div>
              <!-- <div class="labels_"><label v-for="tag in item.productTag">{{tag}}</label></div> -->
              <div class="price_wrap_">
                产品报价
                <label class="price_"
                  ><span class="num_">{{ item.minPrice || "--" }}</span>
                  元起</label
                >
                <a-button
                  @click="fetchJumpLink(item.policyTemplateCode)"
                  class="pos_r_"
                  size="large"
                  type="primary"
                  >查看详情</a-button
                >
              </div>
            </div>
          </a-list-item>
        </a-list>
        <div v-else-if="productList && productList.length == 0" class="empty_">
          <img src="../../assets/index.png" />
          未查询到相关产品
        </div>
        <!-- <div v-if="productList && productList.length > 0" class="page_wrap_">
                    <a-pagination @change="handlePageChange" :total="total" pageSize=5 />
                </div> -->
      </div>
    </div>
    <footbar></footbar>
  </div>
</template>
<style lang="scss" scoped>
.page_ {
  font-size: 12px;
  .mrg_r36_ {
    margin-right: 36px;
  }
  .hline_ {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .tabs_wrap_ {
    font-size: 13px;
    .item_ {
      position: relative;
      display: inline-block;
      margin-left: 26px;
      padding: 17px 0;
      cursor: pointer;
      &.active_ {
        border-bottom: 2px solid #ff4c1c;
        .overlay_ {
          display: block;
        }
      }
      .overlay_ {
        display: none;
        position: absolute;
        background: #fff;
        font-size: 12px;
        line-height: 12px;
        padding: 25px;
        min-width: 700px;
        box-shadow: 0px 1px 17px 0px rgba(0, 0, 0, 0.03);
        top: 55px;
        left: 0;
        z-index: 10;
        .select_item_ {
          .title_ {
            border-left: 2px solid #ff4c1c;
            padding-left: 11px;
          }
          .content_ {
            padding: 16px 12px 15px;
            color: #666;
            span {
              display: inline-block;
              margin-right: 49px;
              margin-bottom: 12px;
            }
          }
        }
      }
      &:hover {
        border-bottom: 2px solid #ff4c1c;
        .overlay_ {
          display: block;
        }
      }
    }
  }
  .banner_wrap_ {
    // background: #FFB9AF;
    height: 320px;
    .ant-carousel {
      width: 100%;
      margin: 0 auto;
    }
    .item_ {
      height: 320px;
      img {
        width: 100%;
        height: 320px;
        object-fit: cover;
        margin: 0 auto;
      }
    }
  }
  .hots_ {
    margin: 17px auto 32px !important;
    li {
      position: relative;
      display: inline-block;
      width: 324px;
      height: 192px;
      margin-right: 14px;
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.05);
      cursor: pointer;
      img {
        width: 100%;
        height: 192px;
        object-fit: cover;
      }
      & > div {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        padding: 20px;
      }
      &:last-child {
        margin-right: 0;
      }
      .labels_wrap_ {
        label {
          display: inline-block;
          padding: 4px 6px;
          border: 1px solid #ff4c1c;
          font-size: 10px;
        }
      }
      .title_ {
        width: 148px;
        font-size: 17px;
        margin: 8px 0 10px;
        color: #000000;
      }
      .sub_title_ {
        color: #666666;
      }
      .num_ {
        font-size: 17px;
        position: absolute;
        left: 20px;
        bottom: 20px;
      }
    }
  }
  .product_section_ {
    .title_ {
      font-size: 17px;
      margin-bottom: 17px;
    }
  }
}
.product_list_ {
  .empty_ {
    text-align: center;
    min-height: 300px;
    img {
      display: block;
      margin: 0 auto;
    }
  }
  li {
    position: relative;
    border: 1px solid #e5e5e5;
    margin-bottom: 29px;
    &:hover {
      border: 1px solid #f5692c;
    }
  }
  .left_ {
    width: 330px;
    height: 204px;
    display: inline-block;
    background: #eee;
    vertical-align: top;
    img {
      width: 100%;
      height: 204px;
      object-fit: cover;
    }
  }
  .right_wrap_ {
    display: inline-block;
    padding: 19px 29px;
    .company_ {
      position: absolute;
      top: 23px;
      right: 42px;
      font-size: 14px;
      color: #999;
    }
  }
  .price_wrap_ {
    font-size: 14px;
    color: #333;
    .price_ {
      margin-left: 8px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(255, 39, 39, 1);
      .num_ {
        font-size: 28px;
      }
    }
    .pos_r_ {
      position: absolute;
      right: 41px;
      bottom: 21px;
    }
  }
  .title_ {
    font-size: 28px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 18px;
  }
  .desc_ {
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    margin-bottom: 14px;
    white-space: pre-wrap;
  }
  .labels_ {
    margin-bottom: 19px;
    label {
      border: 1px solid #999999;
      padding: 6px 10px;
      font-size: 14px;
      color: #999;
      margin-right: 19px;
      display: inline-block;
    }
  }
}
</style>
<script>
import navbar from "./components/navbar";
import footbar from "./components/footbar";
import api from "@/utils/api";
import { getLogined, getToken, getUserInfo } from "@/utils/authorized";
export default {
  data() {
    document.title = "光大商城";
    return {
      productList: [{}],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      bannerList: [],
      hotProducts: [],
      classList: [],
      activeIndex: 0,
      userName: "",
      pagination: {
        pageSize: 10,
        pageNum: 1,
        current: 1,
        total: 0,
        onChange: (page) => this.handlePageChange(page),
      },
    };
  },
  components: {
    navbar,
    footbar,
  },
  mounted() {
    if (getUserInfo() && getUserInfo().userName) {
      this.userName = getUserInfo().userName;
      this.fetchData();
    } else {
      this.$router.push({
        name: "gd-login",
      });
    }
  },
  methods: {
    fetchJumpLink(url) {
      window.open(url);
    },
    fetchData(productName) {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      if (productName) {
        params.productName = productName;
      }
      api
        .queryGdProduct({
          userName: this.userName,
        })
        .then((res) => res.data)
        .then((data) => {
          console.log(data, "data产品----");
          if (data.returnCode === "00" && data.productList.length > 0) {
            this.productList = data.productList || [];
            this.pagination.total = this.productList.length;
          } else {
            this.$message.error("暂无产品", 3);
          }
        });

        let coreUserId = 193  //后台配置用户:GDSC01 GDsc01-01
        if(window.location.href.indexOf('run4wd') > -1){
          coreUserId = 105
        }

      api
        .queryPcStore({ coreUserId: coreUserId })
        .then((res) => res.data)
        .then((data) => {
          const { corebanners, pcstoreProductVos } = data.content || {};
          this.bannerList = corebanners || [];
          this.hotProducts = pcstoreProductVos || [];
        });
      api
        .queryProductClassList()
        .then((res) => res.data)
        .then((data) => {
          this.classList.push({ productClassName: "首页" });
          this.classList.push(data.content[0]);
        });
    },
    handlePageChange(e) {
      console.log("handlePageChange -> ", e);
      this.pagination.current = e;
    },
    changeIndex(index) {
      this.activeIndex = index;
      console.log(this.activeIndex, "this.activeIndex");
    },
    hidePanel() {
      var sp = document.getElementById("overlay");
      if (sp) {
        if (!sp.contains(event.target)) {
          this.activeIndex = 0;
        }
      }
    },
  },
};
</script>
